var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastLearner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.4,60.42c-2.48,0.93-4.9,1.8-7.29,2.73c-1.27,0.49-1.48,0.4-1.48-0.98c0-8.22,0.01-16.44-0.03-24.67 c0-0.94,0.26-1.51,1.18-1.83c3.28-1.18,6.54-2.4,9.8-3.63c1.34-0.5,2.68-1.01,4-1.57c2.04-0.88,3.12-0.22,3.13,1.98 c0,0.07,0,0.15,0,0.22c-0.02,0.92,0.24,1.98-0.13,2.72c-0.4,0.81-1.66,0.5-2.47,0.87c-1.09,0.5-2,1.21-2.39,2.44 c-0.87,2.71-0.85,5.44-0.12,8.15c0.52,1.93,1.96,2.99,3.94,3.15c0.98,0.08,1.25,0.51,1.19,1.41c-0.06,0.81-0.06,1.63,0,2.43 c0.07,0.9-0.44,1.49-1.12,1.73c-2.28,0.78-3.98,2.46-5.97,3.67C43.93,59.68,43.2,60.01,42.4,60.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.88,45.32c0.02-1.46,0.09-2.83,0.02-4.19c-0.16-2.86-1.16-4.66-4.45-5.24c-0.85-0.15-1.13-0.48-1.09-1.29 c0.04-0.81,0-1.62,0.02-2.43c0.05-1.83,1.08-2.55,2.79-1.83c1.63,0.69,3.3,1.24,4.95,1.84c3,1.09,5.96,2.29,8.96,3.38 c1.07,0.39,1.41,1,1.4,2.14c-0.05,8.11-0.03,16.23-0.04,24.34c0,1.6-0.15,1.65-1.65,1.05c-2.62-1.05-5.32-1.91-7.75-3.39 c-1.28-0.78-2.57-1.56-3.85-2.35c-1.09-0.68-2.22-1.27-3.45-1.69c-0.83-0.29-1.34-0.89-1.36-1.82c-0.01-0.33-0.01-0.66-0.01-1 c0.01-0.81-0.21-1.75,0.12-2.39c0.37-0.72,1.5-0.32,2.22-0.66c1.29-0.6,2.43-1.37,2.8-2.88C17.63,46.42,17.75,45.91,17.88,45.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.2,7.21c1.57,4.26-0.5,9.29-4.45,11.48c-3.51,1.94-8.3,1.43-11.19-1.23c-2.58-2.37-4-6.18-2.78-9.93 c0.96-2.95,2.7-5.13,5.57-6.24c1.59-0.62,3.28-0.91,5.07-0.6c2.42,0.42,4.48,1.4,6.03,3.29C40.21,4.91,40.99,5.87,41.2,7.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.21,25.55c0.66,0.95,1.27,1.84,1.91,2.75c-1.39,1.03-2.95,1.33-4.37,1.85c-1.27,0.46-2.5,1.03-3.79,1.46 c-1.21,0.4-2.45,0.75-3.62,1.32c-0.76,0.37-1.6,0.35-2.38,0.07c-2-0.71-3.98-1.51-5.97-2.25c-1.31-0.49-2.62-0.94-3.93-1.41 c-0.69-0.25-1.39-0.48-2-1.11c1.55-2.17,2.78-4.56,4.64-6.52c0.7-0.74,1.55-0.74,2.42-0.27c3.89,2.13,7.79,2.08,11.72,0.09 c1.36-0.69,1.92-0.59,2.9,0.54C41.66,23.13,42.49,24.26,43.21,25.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.16,40.61c1.87-1.51,3.97-1.84,6.2-1.61c0.76,0.08,1.19,0.59,1.26,1.33c0.17,1.76,0.17,3.53-0.01,5.3 c-0.08,0.79-0.54,1.22-1.39,1.29c-1.48,0.12-2.98,0.11-4.41-0.14c-1.42-0.24-2.25-1.41-2.66-2.81C5.77,42.65,6.12,41.57,7.16,40.61 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.34,46.83c-0.75-0.39-0.94-1.03-0.96-1.7c-0.04-1.4-0.05-2.8,0-4.2c0.05-1.46,0.61-1.88,2.07-1.97 c2.18-0.13,4.03,0.52,5.64,2c1.02,0.93,1.41,2.7-0.03,4.03C55.13,46.76,52.92,47.23,50.34,46.83z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastLearner);
export default __webpack_public_path__ + "static/media/fastLearner.d72de13631bc60d5e5d65aaf3abdb939.svg";
export { ForwardRef as ReactComponent };